
import { Component, Inject } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

// dialog component
@Component({
    selector: "file-violation-dialog",
    templateUrl: "./file-violation-dialog.html",
    styleUrls: ['./file-violation-dialog.scss'],
})
export class FileViolationDialog {
    // errorType: string = '';
    // errorMessage: string = '';
    // errorTitle: string = 'Upload Denied';
    // constructor(public dialogRef: MatDialogRef<FileViolationDialog>, @Inject(MAT_DIALOG_DATA) public data: any) {
    //     this.errorType = '';
    //     this.errorType = data;

    // }
    // onCancel(): void {
    //     this.dialogRef.close(null);
    // }

    errorType: string = '';
    uploadedfiletype: string = '';
    uploadedfilesize: string = '';
    errorMessage: string = '';
    errorTitle: string = 'Upload Denied';
    constructor(public dialogRef: MatDialogRef<FileViolationDialog>, @Inject(MAT_DIALOG_DATA) public data: any) {
        this.errorType = data.type;
        this.uploadedfilesize = data.filesize;
        this.uploadedfiletype = data.filetype;
        this.errorMessage = data.message;
        if (data && data.hasOwnProperty('title')) {
            this.errorTitle = data.title;
        }
    }

    onCancel(): void {
        this.dialogRef.close(null);
    }
}

// bottom sheet component
// @Component({
//     selector: "file-violation-dialog",
//     templateUrl: "./file-violation-dialog.html",
//     styleUrls: ['./file-violation-dialog.scss'],
// })
// export class FileViolationBottomSheet {
//     errorType: string = '';
//     constructor(public bottomSheetRef: MatBottomSheetRef<FileViolationBottomSheet>, @Inject(MAT_BOTTOM_SHEET_DATA) public data: any) {
//         this.errorType = '';
//         this.errorType = data;
//     }
// }